import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { GridItem } from 'foundations-components/transitional/components/Grid';
import { LEFT_GRID_SIZE, RIGHT_GRID_SIZE } from '../../constants/Sizes';
import FormattedPrice from '../Utilities/FormattedPrice';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TaxBreakdowns = ({
  currencyCode,
  taxBreakdowns,
  taxesCalculatedAtCheckout = false
}) => {
  return taxBreakdowns.map(taxBreakdown => /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(GridItem, {
      size: LEFT_GRID_SIZE,
      marginBlock: "200",
      children: /*#__PURE__*/_jsxs(Text, {
        as: "h6",
        textAlign: "start",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "payments.taxBreakdown",
          options: {
            taxLabel: taxBreakdown.label,
            taxRate: taxBreakdown.percentage
          }
        }), taxesCalculatedAtCheckout && /*#__PURE__*/_jsx(Badge, {
          use: "pantera",
          marginInlineStart: "100",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "payments.taxFinal"
          })
        })]
      })
    }, taxBreakdown.label), /*#__PURE__*/_jsx(GridItem, {
      marginBlockStart: "200",
      "data-test-id": `tax-breakdown-${taxBreakdown.label}`,
      size: RIGHT_GRID_SIZE,
      children: /*#__PURE__*/_jsx(Text, {
        textAlign: "end",
        typography: "body-125",
        children: /*#__PURE__*/_jsx(FormattedPrice, {
          currencyCode: currencyCode,
          price: taxBreakdown.amount
        })
      })
    })]
  }));
};
export default TaxBreakdowns;